"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTaskInventoriesQuantity = void 0;
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var isNil_1 = __importDefault(require("lodash/isNil"));
var hierarchy_actions_1 = require("../task_inventories/hierarchy_actions");
var value_retrieval_1 = require("../task_inventories/value_retrieval");
var utils_1 = require("../utils");
function totalQuantities(taskInventories, uniqueInventoryFields) {
    if (uniqueInventoryFields === void 0) { uniqueInventoryFields = []; }
    if (taskInventories.some(function (taskInventory) { return taskInventory.inventory_id; })) {
        // For backward compatibility
        uniqueInventoryFields = ['inventory_id'];
    }
    var mapping = {};
    var unknownQuantities = 0;
    taskInventories.forEach(function (taskInventory) {
        var hash = (0, utils_1.generateHash)(taskInventory, uniqueInventoryFields, false);
        var quantityValue = (0, value_retrieval_1.getTaskInventoryNumericValue)(taskInventory, 'original_quantity') * (taskInventory.quantityFactor || 1);
        if ((0, isNil_1.default)(hash)) {
            unknownQuantities += quantityValue;
        }
        else {
            var quantities = mapping[hash] || { pickup: 0, dropoff: 0 };
            var field = taskInventory.pending ? 'pickup' : 'dropoff';
            quantities[field] += quantityValue;
            mapping[hash] = quantities;
        }
    });
    return (Object.values(mapping).reduce(function (acc, value) { return acc + Math.max(value.pickup, value.dropoff); }, 0) +
        unknownQuantities);
}
function calculateTaskInventoriesQuantity(task, uniqueInventoryFields) {
    var clonedTaskInventories = (0, cloneDeep_1.default)(task.task_inventories || []);
    var nestedTaskInventories = (0, hierarchy_actions_1.buildTaskInventoriesHierarchy)(clonedTaskInventories);
    var taskInventories = (0, flatMap_1.default)(nestedTaskInventories, function (taskInventory) {
        return (0, hierarchy_actions_1.flatTaskInventoryHierarchy)(taskInventory);
    });
    return totalQuantities(taskInventories, uniqueInventoryFields);
}
exports.calculateTaskInventoriesQuantity = calculateTaskInventoriesQuantity;
//# sourceMappingURL=quantity_aggregator.js.map